// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uXx6llpaYr0k_7aL{width:100%;max-width:clamp(300px,100%,var(--pyo-page-content-max-width, 1148px));width:100%;margin:0 auto}.uXx6llpaYr0k_7aL ._8EetbBb8MwPRARk{max-width:100%;width:1148px}.uXx6llpaYr0k_7aL .hH473dV9eV0XR0VM{width:100%;display:flex;justify-content:space-between;align-items:center}.uXx6llpaYr0k_7aL .hH473dV9eV0XR0VM.IQZxhJDP0YDBvEjV{flex-direction:column;justify-content:flex-start}.uXx6llpaYr0k_7aL .b08Kbje6JpsGYUad{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `uXx6llpaYr0k_7aL`,
	"title": `_8EetbBb8MwPRARk`,
	"utils": `hH473dV9eV0XR0VM`,
	"mobile": `IQZxhJDP0YDBvEjV`,
	"content": `b08Kbje6JpsGYUad`
};
export default ___CSS_LOADER_EXPORT___;
